<wiz-vgroup width="100%">
  <wiz-label [wizLabel]="parentLabel" width="200px" [wizTextBehavior]="'truncate'" [visible]="isFirst()"></wiz-label>
  <wiz-hgroup wizValidationContainer #hgMain verticalAlign="center" gap="5" width="100%">
    <wiz-icon class="image-purple" [visible]="!isFirst()" (click)="doDelete()">delete</wiz-icon >
    <wiz-spacer width="16px" height="16px" [visible]="isFirst()"></wiz-spacer>
    <wiz-text-input
      width="120px"
      #tiShortCode
      [wizMandatory]="true"
      [wizValidator]="uniqueShortCodeValidator()"
      [wizShowLabel]="false"
    ></wiz-text-input>
    <wiz-datefield width="130px" #dfStartDate wizValidator [wizShowLabel]="false" [wizMandatory]="true"></wiz-datefield>
    <wiz-datefield width="130px" #dfEndDate wizValidator [wizShowLabel]="false" [wizMandatory]="true"></wiz-datefield>
  </wiz-hgroup>
</wiz-vgroup>
